(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4426],{

/***/ 16235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image; },
/* harmony export */   "NY": function() { return /* binding */ Fallback; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* unused harmony exports createAvatarScope, Avatar, AvatarImage, AvatarFallback */
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40192);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29563);
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95355);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32707);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
const[c,i]=(0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)("Avatar");const[s,l]=c("Avatar");const Avatar=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((t,a)=>{const{__scopeAvatar:r,...c}=t,[i,l]=react__WEBPACK_IMPORTED_MODULE_0__.useState("idle");/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(s,{scope:r,imageLoadingStatus:i,onImageLoadingStatusChange:l},/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__/* .Primitive.span */ .W.span,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({},c,{ref:a})))}));/*#__PURE__*/const AvatarImage=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((r,c)=>{const{__scopeAvatar:i,src:s,onLoadingStatusChange:d=(()=>{}),...m}=r,u=l("AvatarImage",i),f=function(e){const[t,a]=react__WEBPACK_IMPORTED_MODULE_0__.useState("idle");return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{if(!e)return void a("error");let t=!0;const r=new window.Image,o=e=>()=>{t&&a(e)};return a("loading"),r.onload=o("loaded"),r.onerror=o("error"),r.src=e,()=>{t=!1}}),[e]),t}(s),p=(0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_4__/* .useCallbackRef */ .W)((e=>{d(e),u.onImageLoadingStatusChange(e)}));return (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_5__/* .useLayoutEffect */ .b)((()=>{"idle"!==f&&p(f)}),[f,p]),"loaded"===f?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__/* .Primitive.img */ .W.img,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({},m,{ref:c,src:s})):null}));/*#__PURE__*/const AvatarFallback=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((t,a)=>{const{__scopeAvatar:r,delayMs:c,...i}=t,s=l("AvatarFallback",r),[d,m]=react__WEBPACK_IMPORTED_MODULE_0__.useState(void 0===c);return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{if(void 0!==c){const e=window.setTimeout((()=>m(!0)),c);return()=>window.clearTimeout(e)}}),[c]),d&&"loaded"!==s.imageLoadingStatus?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_2__/* .Primitive.span */ .W.span,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({},i,{ref:a})):null}));/*#__PURE__*/const Root=Avatar;const Image=AvatarImage;const Fallback=AvatarFallback;
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 15273:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boards",
      function () {
        return __webpack_require__(64015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; },
  "z": function() { return /* binding */ avatar_Verified; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.module.js
var index_module = __webpack_require__(16235);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/avatar/styles.ts


var Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex"
});
var StyledRoot = (0,stitches/* styled */.zo)(index_module/* Root */.fC, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    overflow: "hidden",
    userSelect: "none",
    width: 128,
    height: 128,
    backgroundColor: "$secondaryBackground",
    variants: {
        round: {
            true: {
                borderRadius: 9999
            }
        }
    }
});
var StyledImage = (0,stitches/* styled */.zo)(index_module/* Image */.Ee, {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit"
});
var StyledFallback = (0,stitches/* styled */.zo)(index_module/* Fallback */.NY, {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var Verified = (0,stitches/* styled */.zo)("div", {
    margin: "0 $space$5",
    fontSize: 14
});
var Path = (0,stitches/* styled */.zo)("path", {});

;// CONCATENATED MODULE: ./src/components/avatar/index.tsx



var Avatar = function(param) {
    var username = param.username, path = param.path, _round = param.round, round = _round === void 0 ? true : _round, size = param.size;
    if (size) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
                round: round,
                css: {
                    width: size,
                    height: size
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: path,
                        alt: "".concat(username, " profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                        delayMs: path ? 600 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                            hash: username
                        })
                    })
                ]
            })
        });
    }
    // adjusts to 100% parent
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        css: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
            round: round,
            css: {
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                "&:after": {
                    content: "",
                    display: "block",
                    paddingTop: "calc(1 * 100%);"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: path,
                    alt: "".concat(username, " profile"),
                    css: {
                        position: "absolute",
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                    delayMs: path ? 600 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                        hash: username
                    })
                })
            ]
        })
    });
};
var avatar_Verified = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _secondary = param.secondary, secondary = _secondary === void 0 ? false : _secondary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    d: "M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z",
                    css: {
                        fill: secondary ? "$secondaryFill" : "$primaryFill"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z",
                    css: {
                        fill: "$primaryBackground"
                    }
                })
            ]
        })
    });
// return (
//   <svg width={size} height={size} viewBox="0 0 18 18">
//     <g fill="none" fillRule="evenodd">
//       <path fill="#38D" fillRule="nonzero" d="M9 18A9 9 0 108.999-.001 9 9 0 009 18z" />
//       <path stroke="#FFF" strokeWidth="2" d="M4.13 8.767l3.086 3.087 6.656-6.656" />
//     </g>
//   </svg>
// );
};


/***/ }),

/***/ 13707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ ThumbnailBoard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/ipfs.ts
var ipfs = __webpack_require__(80125);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/thumbnail-board/styles.ts

var Square = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$secondaryBackground",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    "&:after": {
        content: "",
        display: "block",
        paddingTop: "calc(1 * 100%);"
    }
});
var Draft = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    top: 8,
    left: 8,
    zIndex: 1
});
var TokenHolder = (0,stitches/* styled */.zo)("div", {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    "& > *": {
        position: "absolute",
        width: "50%",
        height: "50%",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        "&:nth-child(4n + 1)": {
            top: "0%",
            left: "0%"
        },
        "&:nth-child(4n + 2)": {
            top: "0%",
            left: "50%"
        },
        "&:nth-child(4n + 3)": {
            top: "50%",
            left: "0%"
        },
        "&:nth-child(4n + 4)": {
            top: "50%",
            left: "50%"
        }
    }
});

;// CONCATENATED MODULE: ./src/components/thumbnail-board/index.tsx




var ThumbnailBoard = function(param) {
    var cover = param.cover, images = param.images, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
        css: {
            flexDirection: "column"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Square, {
            css: {
                backgroundImage: cover && "url(".concat((0,ipfs/* getURLFromIPFSURI */.vR)(cover, ipfs/* Node.INFURA */.NB.INFURA), ")")
            },
            children: [
                !cover && images && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenHolder, {
                    children: images.map(function(image) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                backgroundImage: "url(".concat(image, ")"),
                                imageRendering: "pixelated"
                            }
                        }, image);
                    })
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                    css: {
                        i: {
                            fontSize: 64
                        }
                    },
                    children: icon
                })
            ]
        })
    });
};


/***/ }),

/***/ 46493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ PREVIEW_VIDEO_WIDTHS; },
/* harmony export */   "L8": function() { return /* binding */ FFMPEG_QUALITY_LEVEL; },
/* harmony export */   "Nq": function() { return /* binding */ PREVIEW_VIDEO_FILENAME_PREFIX; },
/* harmony export */   "UV": function() { return /* binding */ FULL_VIDEO_FILENAME_PREFIX; },
/* harmony export */   "Wc": function() { return /* binding */ PREVIEW_IMAGE_WIDTHS; },
/* harmony export */   "az": function() { return /* binding */ FULL_VIDEO_HEIGHTS_POW2; },
/* harmony export */   "h7": function() { return /* binding */ FULL_VIDEO_HEIGHTS_DEFAULT; },
/* harmony export */   "ks": function() { return /* binding */ PREVIEW_VIDEO_MAX_DURATION; },
/* harmony export */   "kx": function() { return /* binding */ ORIGINAL_FILENAME_PREFIX; },
/* harmony export */   "mM": function() { return /* binding */ PREVIEW_IMAGE_FILENAME_PREFIX; },
/* harmony export */   "qI": function() { return /* binding */ PREVIEW_VIDEO_SUBTITLES_PREFIX; },
/* harmony export */   "x8": function() { return /* binding */ FFMEPEG_WASM_ENABLED; }
/* harmony export */ });
var PREVIEW_IMAGE_WIDTHS = [
    480,
    960,
    1024,
    2048
];
var PREVIEW_VIDEO_WIDTHS = [
    480 /* , 960 */ 
];
var FULL_VIDEO_HEIGHTS_POW2 = [
    512 /* , 1024, 2048 */ 
];
var FULL_VIDEO_HEIGHTS_DEFAULT = [
    720 /* , 1080, 1440, 2160 */ 
];
var FFMPEG_QUALITY_LEVEL = 4;
var PREVIEW_VIDEO_MAX_DURATION = 20;
var PREVIEW_IMAGE_FILENAME_PREFIX = "preview_image_";
var PREVIEW_VIDEO_FILENAME_PREFIX = "preview_video_";
var PREVIEW_VIDEO_SUBTITLES_PREFIX = "subtitles_";
var ORIGINAL_FILENAME_PREFIX = "original_";
var FULL_VIDEO_FILENAME_PREFIX = "full_video_";
// uses ffmpeg or cloudinary
var FFMEPEG_WASM_ENABLED = true;


/***/ }),

/***/ 64015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_smart_grid_boards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89669);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);




var Boards = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Boards"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_smart_grid_boards__WEBPACK_IMPORTED_MODULE_2__/* .SmartGridBoards */ .u, {
                    api: "/api/public/boards",
                    limit: _constants__WEBPACK_IMPORTED_MODULE_3__/* .API_LIMIT_PAGE_BOARDS */ .s7
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Boards);


/***/ }),

/***/ 79618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ collectionsFetcher; },
/* harmony export */   "Jy": function() { return /* binding */ auctionsFetcher; },
/* harmony export */   "On": function() { return /* binding */ boardsFetcher; },
/* harmony export */   "T7": function() { return /* binding */ swapsFetcher; },
/* harmony export */   "WR": function() { return /* binding */ tokensFetcher; }
/* harmony export */ });
/* unused harmony export fetcher */
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var tokensFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.tokens;
    });
};
var boardsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.token_lists;
    });
};
var collectionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.collections;
    });
};
var auctionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};
var swapsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};


/***/ }),

/***/ 80125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ getURLFromIPFSorHTTP; },
/* harmony export */   "NB": function() { return /* binding */ Node; },
/* harmony export */   "vR": function() { return /* binding */ getURLFromIPFSURI; }
/* harmony export */ });
/* unused harmony export ensureCIDv1 */
/* harmony import */ var multiformats_cid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81362);
/* eslint-disable no-console */ 
var Node;
(function(Node) {
    Node[Node["INFURA"] = 0] = "INFURA";
    Node[Node["CLOUDFLARE"] = 1] = "CLOUDFLARE";
    Node[Node["PINATA"] = 2] = "PINATA";
    Node[Node["IPFS"] = 3] = "IPFS";
    Node[Node["DWEB"] = 4] = "DWEB";
    Node[Node["VERSUM"] = 5] = "VERSUM";
})(Node || (Node = {}));
var ensureCIDv1 = function(cid) {
    if (cid === "") {
        console.warn("empty cid -----<");
        return "";
    }
    if (!cid.startsWith("baf")) {
        cid = multiformats_cid__WEBPACK_IMPORTED_MODULE_0__/* .CID.parse */ .k.parse(cid).toV1().toString();
    }
    return cid;
};
var getURLFromIPFSURI = function(uri) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.IPFS;
    var parts = uri.replace("ipfs://", "").split("/");
    var cid = parts[0];
    var cidv1 = ensureCIDv1(cid);
    var path = parts.length ? "/".concat(parts.slice(1).join("/")) : "";
    switch(type){
        case Node.CLOUDFLARE:
            return "https://cloudflare-ipfs.com/ipfs/".concat(cidv1).concat(path);
        case Node.INFURA:
            return "https://".concat(cidv1, ".ipfs.infura-ipfs.io").concat(path);
        case Node.PINATA:
            return "https://gateway.pinata.cloud/ipfs/".concat(cidv1).concat(path);
        case Node.IPFS:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
        case Node.DWEB:
            return "https://".concat(cidv1, ".ipfs.dweb.link").concat(path);
        case Node.VERSUM:
            return "https://ipfs.versum.cloud/ipfs/".concat(cidv1).concat(path);
        default:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
    }
};
// converts ipfs:// if match or returns https://
var getURLFromIPFSorHTTP = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", node = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.INFURA;
    if (value && value.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(value, node);
    }
    return value;
};


/***/ }),

/***/ 56373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ getViewerEditionsOutsideMarket; },
/* harmony export */   "Id": function() { return /* binding */ extractMedium; },
/* harmony export */   "KE": function() { return /* binding */ getVideoSubtitles; },
/* harmony export */   "NJ": function() { return /* binding */ getTags; },
/* harmony export */   "P$": function() { return /* binding */ getResponsiveVideos; },
/* harmony export */   "_U": function() { return /* binding */ getSmallestImageBoardPreview; },
/* harmony export */   "hD": function() { return /* binding */ getWebDimensions; },
/* harmony export */   "j8": function() { return /* binding */ getArtifactUri; },
/* harmony export */   "t_": function() { return /* binding */ getDimensions; },
/* harmony export */   "to": function() { return /* binding */ getResponsiveCover; },
/* harmony export */   "vy": function() { return /* binding */ getResponsiveImages; },
/* harmony export */   "yb": function() { return /* binding */ getVideoPoster; }
/* harmony export */ });
/* unused harmony exports getRandomIPFSNode, getSrcSet, getViewerEditionsOnSwap, getViewerEditionsOnAuction */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _lib_media_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46493);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6767);
/* harmony import */ var _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80125);

/* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ 



var getTags = function(tags) {
    return tags.map(function(e) {
        return e.tag.name;
    });
};
// defines a max of images on the srcset on feeds
// 1 would generate the 480px image
// 2 would generate the 480px + 960px image
var FEED_MAX_IMAGE_PREVIEW = 2; // min value is 1, recommended value is 2
var getRandomIPFSNode = function() {
    var options = [
        Node.INFURA,
        Node.IPFS /* , Node.VERSUM */ 
    ];
    var index = Math.floor(Math.random() * options.length);
    return options[index];
};
var getWebDimensions = function(formats, platform) {
    if (platform.name === _constants__WEBPACK_IMPORTED_MODULE_0__/* .Platforms.VERSUM */ .YK.VERSUM) {
        if (formats.length) {
            var ref;
            var og = (ref = formats[0]) === null || ref === void 0 ? void 0 : ref.dimensions;
            if ((og === null || og === void 0 ? void 0 : og.unit) === "ratio") {
                var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(og.value.split(":"), 2), width = ref1[0], height = ref1[1];
                var a = parseFloat(width) / parseFloat(height);
                return {
                    width: a * 100000,
                    height: 100000
                };
            }
            if ((og === null || og === void 0 ? void 0 : og.unit) === "px") {
                var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(og.value.split("x"), 2), width1 = ref2[0], height1 = ref2[1];
                return {
                    width: parseFloat(width1),
                    height: parseFloat(height1)
                };
            }
        }
        return null;
    }
    return {
        width: 960,
        height: 960
    };
};
var getDimensions = function(formats) {
    // some previews are smaller than the biggest dimension available.
    var preview = formats.filter(function(e) {
        return e.mimeType.includes("image");
    });
    // if there are no preview metada, try checking for the original asset
    if (preview.length === 0) {
        preview = formats;
    }
    var dimensions = preview.filter(function(e) {
        return e.dimensions;
    }).map(function(e) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.dimensions.value.split("x"), 2), width = ref[0], height = ref[1];
        return {
            width: parseFloat(width),
            height: parseFloat(height)
        };
    }).sort(function(a, b) {
        return b.width - a.width;
    });
    // if there is a "dimensions array"
    if (dimensions.length > 0) {
        return dimensions;
    }
    // if no "dimensions array", return default settings
    return [
        {
            width: 960,
            height: 960
        }
    ];
};
var getSrcSet = function(formats) {
    var inDetailView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, limitToMax = arguments.length > 2 ? arguments[2] : void 0;
    // get all images on formats (including the original) // changing to excluding the original
    var images = formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }) // includes original (gifs)
    .sort(function(a, b) {
        return a.dimensions.value.split("x")[0] - b.dimensions.value.split("x")[0]; // order from smallest to largest
    }).filter(function(_data, index) {
        // on feed dont show all resolutions
        if (!inDetailView && index > FEED_MAX_IMAGE_PREVIEW - 1) {
            return false;
        }
        if (limitToMax && index > limitToMax) {
            return false;
        }
        // in detail view show all resolutions
        return true;
    }).sort(function(a, b) {
        return b.dimensions.value.split("x")[0] - a.dimensions.value.split("x")[0]; // order from largest to smallest
    });
    // extract all dimensions and order them by largest to smaller
    var dimensions = images.map(function(e) {
        return e.dimensions.value.split("x")[0];
    }).sort(function(a, b) {
        return b - a;
    });
    // sorting order needs to be smaller to largest
    var node = inDetailView ? _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .Node.INFURA */ .NB.INFURA : undefined;
    return images.map(function(e, i) {
        var src = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, node);
        return "".concat(src, " ").concat(dimensions[i], "w");
    }).join(", ");
};
// was INFURA
var getArtifactUri = function(token, nodeType) {
    var src = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(token.artifact_uri, nodeType);
    var alt = token.title;
    var dimensions = getDimensions(token.formats);
    var ref = dimensions[0], width = ref.width, height = ref.height;
    return {
        src: src,
        width: width,
        height: height,
        alt: alt
    };
};
var getResponsiveImages = function(token) {
    var inDetailView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, limitToMax = arguments.length > 2 ? arguments[2] : void 0;
    var dimensions = getDimensions(token.formats).sort(function(param, param1) {
        var a = param.width, b = param1.width;
        return a - b;
    }) // order from smallest to largest
    .filter(function(_data, index) {
        // on feed view dont show the highest resolution images as they slow down page loading
        if (!inDetailView && index > FEED_MAX_IMAGE_PREVIEW - 1) {
            return false;
        }
        if (limitToMax && index > limitToMax) {
            return false;
        }
        // in detail view show all resolutions
        return true;
    });
    var width = dimensions[dimensions.length - 1].width;
    // we define the image max width to be the largest of the dimensions array width
    var sizes = "(max-width: ".concat(width, "px) 100vw, ").concat(width, "px");
    var srcset = getSrcSet(token.formats, inDetailView, limitToMax);
    if (sizes && srcset) {
        return {
            sizes: sizes,
            srcset: srcset
        };
    }
    return null;
};
var getResponsiveVideos = function(token, nodeType) {
    // get all preview videos
    var previews = token.formats.filter(function(e) {
        var ref;
        return ((ref = e.fileName) === null || ref === void 0 ? void 0 : ref.includes(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_FILENAME_PREFIX */ .Nq)) && e.mimeType === _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP4 */ .HY.MP4;
    }).sort(function(a, b) {
        return b - a;
    });
    if (previews.length > 0) {
        // return both versions, its up for the WrapperComponent (JSX) to decide which one to render
        return previews.map(function(e) {
            return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, nodeType);
        });
    }
    return null;
};
var getResponsiveCover = function(token) {
    // similar to responsive images, its used on any asset that renders an image but its artifactUri is not an image.
    // e.g.: audio/3d/pdf
    // since the artifact_uri on an audio track is an mp3 and the cover is on the formats
    // we need to handle the logic differently than we do with images (which is a combination of getArtifactUri and getResponsiveImages)
    var dimensions = getDimensions(token.formats);
    var width = dimensions[0].width;
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b - a;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri);
    });
    var src = previews[0];
    var sizes = "(max-width: ".concat(width, "px) 100vw, ").concat(width, "px");
    var srcset = getSrcSet(token.formats);
    if (src && sizes && srcset) {
        return {
            src: src,
            sizes: sizes,
            srcset: srcset
        };
    }
    return null;
};
var getVideoPoster = function(token) {
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b - a;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri);
    });
    return previews.length > 0 ? previews[0] : "";
};
var getVideoSubtitles = function(token) {
    // get all subtitlestou a comer das-m
    var subtitles = token.formats.filter(function(e) {
        var ref;
        return ((ref = e.fileName) === null || ref === void 0 ? void 0 : ref.includes(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_SUBTITLES_PREFIX */ .qI)) && e.mimeType === _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.VTT */ .HY.VTT;
    }).map(function(st) {
        // this function gets the subtitles fileName and generates a label and srcLang
        // because those are not TZIP21 spec
        var getPropsFromName = function(value) {
            var label = "English";
            var srcLang = "en";
            var tail = value.indexOf(".vtt");
            var key = String(value).slice(_lib_media_config__WEBPACK_IMPORTED_MODULE_4__/* .PREVIEW_VIDEO_SUBTITLES_PREFIX.length */ .qI.length, tail);
            switch(key){
                case "de":
                    label = "German";
                    srcLang = key;
                    break;
                default:
                    label = "English";
                    srcLang = "en";
            }
            return {
                label: label,
                srcLang: srcLang
            };
        };
        var ref = getPropsFromName(st.fileName), label = ref.label, srcLang = ref.srcLang;
        var url = (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(st.uri, _utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .Node.CLOUDFLARE */ .NB.CLOUDFLARE);
        return {
            label: label,
            srcLang: srcLang,
            file: url
        };
    });
    if (subtitles) {
        return subtitles;
    }
    return undefined;
};
var getSmallestImageBoardPreview = function(token, node) {
    var previews = token.formats.filter(function(e) {
        return e.dimensions && e.mimeType.includes("image");
    }).sort(function(a, b) {
        return b.fileSize - a.fileSize;
    }).map(function(e) {
        return (0,_utils_ipfs__WEBPACK_IMPORTED_MODULE_2__/* .getURLFromIPFSURI */ .vR)(e.uri, node);
    });
    var src = previews[previews.length - 1];
    if (src) {
        return {
            src: src
        };
    }
    return null;
};
// returns the amount of editions the user has in their collection
var getViewerEditionsOutsideMarket = function(viewer, holders) {
    return holders.reduce(function(a, c) {
        if (c.holder.user[0].user.id === viewer) {
            return a + c.amount;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on swaps
var getViewerEditionsOnSwap = function(viewer, swaps) {
    return swaps.reduce(function(a, c) {
        if (c.seller.user[0].user.id === viewer) {
            return a + c.amount_left;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on auctions
var getViewerEditionsOnAuction = function(viewer, auctions) {
    return auctions.reduce(function(a, c) {
        if (c.seller.user[0].user.id === viewer) {
            return a + 1;
        }
        return a;
    }, 0);
};
// returns the amount of editions the user has on offers
// export const getViewerEditionsOnOffers = (viewer: string, offers: any[]) => {
//   return offers.reduce((a: any, c: any) => {
//     if (c.buyer.user[0].user.id === viewer) {
//       return a + 1;
//     }
//     return a;
//   }, 0);
// };
var extractMedium = function(token) {
    var original = token.formats[0];
    var extractDimensions = function(dimensions) {
        if (dimensions) {
            return " | ".concat(dimensions.value).concat(dimensions.unit);
        }
        return "";
    };
    var extractSize = function(size) {
        if (size) {
            return " | ".concat((0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .formatBytes */ .td)(size));
        }
        return "";
    };
    var extractDuration = function(duration) {
        if (duration) {
            return ", ".concat(duration.split(":").reduce(function(acc, time) {
                return 60 * acc + +time;
            }), " seconds"); // converts HH:MM:SS: to seconds
        }
        return "";
    };
    switch(token.mime){
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.GIF */ .HY.GIF:
            return original ? "GIF".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "GIF";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.JPEG */ .HY.JPEG:
            return original ? "JPG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "JPG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.PNG */ .HY.PNG:
            return original ? "PNG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "PNG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.SVG */ .HY.SVG:
            return original ? "SVG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "SVG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP4 */ .HY.MP4:
            return original ? "MP4".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "MP4";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.OGV */ .HY.OGV:
            return original ? "OGG".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "OGG";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.GLB */ .HY.GLB:
            return "GLB";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.MP3 */ .HY.MP3:
            return original ? "MP3".concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "MP3";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.WAV */ .HY.WAV:
            return original ? "WAV".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)).concat(extractDuration(original.duration)) : "WAV";
        case _constants__WEBPACK_IMPORTED_MODULE_0__/* .MimeType.WEB */ .HY.WEB:
            return original ? "WEB".concat(extractDimensions(original.dimensions)).concat(extractSize(original.fileSize)) : "WEB";
        default:
            return "Unknown";
    }
};


/***/ }),

/***/ 46873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useMedia; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useMedia = function(queries, values, defaultValue) {
    var mediaQueryLists = [];
    if (true) {
        mediaQueryLists = queries.map(function(q) {
            return window.matchMedia(q);
        });
    }
    var getValue = function() {
        var index = mediaQueryLists.findIndex(function(mql) {
            return mql.matches;
        });
        return (values === null || values === void 0 ? void 0 : values[index]) || defaultValue;
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getValue), value = ref[0], setValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function() {
            return setValue(getValue);
        };
        mediaQueryLists.forEach(function(mql) {
            return mql.addListener(handler);
        });
        return function() {
            return mediaQueryLists.forEach(function(mql) {
                return mql.removeListener(handler);
            });
        };
    }, []);
    return value;
};


/***/ }),

/***/ 12857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ getScreenName; },
/* harmony export */   "vW": function() { return /* binding */ getUserName; }
/* harmony export */ });
/* unused harmony export sanitiseProfileImage */
/* harmony import */ var _ipfs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80125);
/* harmony import */ var _wallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49058);
/* eslint-disable no-console */ 

var sanitiseProfileImage = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (uri && uri.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(uri, Node.INFURA);
    }
    // otherwise its already resolved
    return uri;
};
var getUserName = function(id, name) {
    var userName = name === id ? (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id) : "@".concat(name);
    userName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id); // eventually remove
    return userName;
};
var getScreenName = function(verified, screenName, id, name) {
    // validate empty screen name before
    var parsedScreenName = screenName;
    // if screen name is null we fill it with the address
    if (!screenName) {
        parsedScreenName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id);
    }
    return verified ? parsedScreenName : getUserName(id, name);
};


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1362,8100,9669,9774,2888,179], function() { return __webpack_exec__(15273); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);